import _ from 'lodash';
import globalStore from '$$globalStore';
import constants from '$$helpers/constants';
import projectsModel from '$$projectModel';
import customDayTemplatesModel from '$$customDayTemplatesModel';
import createWorker from './createWorker';

class ResourceWorker {
  #worker = null;

  #filterGanttIds = [];

  #dataComposers = {
    changeTasks: data => {
      const ganttIdsMap = {};
      const preparedData = {};

      data.forEach(taskChangeData => {
        const ganttId = taskChangeData.gantt_id;

        if (!ganttId) return;

        ganttIdsMap[ganttId] = true;

        if (!preparedData[ganttId]) preparedData[ganttId] = [];

        preparedData[ganttId].push(taskChangeData);
      });

      this.#filterGanttIds = Object.keys(ganttIdsMap);

      return preparedData;
    },
  };

  constructor() {
    this.#initWorker();
  }

  #initWorker() {
    let version = Date.now();

    if (GT.productVersion && GT.productVersion.buildVersion) {
      version = GT.productVersion.buildVersion;
    }

    this.#worker = createWorker(`/workers/resource_worker.js?${version}`);
  }

  #prepareModelsData() {
    const projectsCustomDays = customDayTemplatesModel.serialize();
    const resultData = {
      projectsTasksMap: {},
      projectsResources: {},
      projectConfigs: {},
      commonGanttConfig: {
        start_on_monday: Number(user.settings.start_on_monday),
      },
      constants: {
        RESOURCE_TIME_TYPE: constants.RESOURCE_TIME_TYPE,
      },
    };

    this.#filterGanttIds.forEach(ganttId => {
      const totalData = globalStore.getters['tasksModel/getTotalEstimateDataForProject'](+ganttId);
      const projectConfig = projectsModel.getProjectConfig(+ganttId);
      const customDaysData = projectsCustomDays.find(data => +data.ganttId === +ganttId);

      const workDays = new Array(7).fill(false);

      projectConfig.durationData.showDay.forEach(dayIndex => {
        if (dayIndex === 7) {
          workDays[0] = true; // sunday should be first
        } else {
          workDays[dayIndex] = true;
        }
      });

      resultData.projectsTasksMap[ganttId] = globalStore.getters['tasksModel/getProjectTasksMap'](+ganttId);
      resultData.projectsResources[ganttId] = globalStore.getters['resourcesModel/getResourcesByProjectId'](+ganttId);
      resultData.projectConfigs[ganttId] = {
        durationData: projectConfig.durationData,
        calendar: {
          id: +ganttId,
          worktime: {
            hours: projectConfig.durationData.showTime,
            days: workDays,
          },
        },
        ganttConfig: {
          auto_scheduling: projectConfig.auto_scheduling,
          estimation_mode: projectConfig.estimation_mode,
          apply_resource_calendar: projectConfig.apply_resource_calendar,
          progress: projectConfig.progress,
          resource_loading_type: projectConfig.resource_loading_type,
        },
        customDays: customDaysData ? customDaysData.customDays : [],
        totalDates: {
          start_date: totalData.start_date,
          end_date: totalData.end_date,
        },
      };
    });

    return resultData;
  }

  async calculate(data, composer, action) {
    this.#filterGanttIds = [];
    const updatedData = this.#dataComposers[composer](data);

    if (!updatedData) {
      return Promise.resolve(false);
    }

    const innerData = this.#prepareModelsData();
    const calculatedGanttData = await this.#worker(_.cloneDeep({
      innerData,
      updatedData,
      action: action || composer,
    }));

    return Promise.resolve(calculatedGanttData);
  }
}

export default new ResourceWorker();
